export default "__VITE_ASSET__DFTj57rs__"